import React, { useState } from 'react';
import {
    TableRow,
    TableCell,
    Typography,
    Collapse,
    Card
} from '@mui/material';
import GuestChildTable from './guestChildTable';
import ActionButtons from '../../dashboard/actionButtons';
import EditTextField from '../../../overrides/editField';
import { updateGuestWatcher, deleteGuestWatcher, getViewGuestUserWatcher, getAllGuestUserWatcher } from '../../../../redux/actionCreators/admin/guestManagement';
import { useDispatch } from 'react-redux'
import AddDesign from './addIcon/addEmployeeDesign';
import ViewDesign from './viewIcon/viewEmployeeDesign';
import CreationDialog from '../../../dialog';
import DuplicationDesign from "./addIcon/duplicationDesign";

const GuestTableRow = ({ rowData }) => {
    const dispatch = useDispatch();

    const [expandOpen, setExpandOpen] = useState(false);
    const [status, setStatus] = useState('list');
    const [editData, setEditData] = useState({});
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [addDialogOpen, setAddDialogOpen] = useState(false)
    const [viewDialogOpen, setViewDialogOpen] = useState(false)
    const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false)
    const [dupRfid, setDupRfid] = useState([])

    const handleEditChange = (e) => {
        const { name, value } = e.target
        setEditData({ ...editData, [name]: value })
    }

    const handleEdit = () => {
        let data = { ...rowData }
        setEditData(data);
        setStatus('edit');
    }

    const handleDelete = async () => {
        let data = { "ACTION": "DELETE" }
        await dispatch(deleteGuestWatcher(rowData.NID, { data }))
        setStatus('list');
        setDeleteDialogOpen(false);
    }

    const tickIconFunction = async () => {
        let data = { ...editData }
        data.ACTION = "UPDATE"
        // data.cMenuName = JSON.stringify(editData.cMenuName)
        await dispatch(updateGuestWatcher(rowData.NID, data));
        setStatus('list');
    }

    const cancelIconFunction = () => {
        setEditData({});
        setStatus('list');
    }

    const addIconFunc = () => {
        setAddDialogOpen(true)
        dispatch(getAllGuestUserWatcher())
    }

    const viewIconFunc = () => {
        setViewDialogOpen(true)
        let data = {
            nGuestID: rowData.NID
        }
        dispatch(getViewGuestUserWatcher(data))
        dispatch(getAllGuestUserWatcher())
    }

    return (
        <>
            <TableRow
                hover
                tabIndex={-1}
            >
                {status === 'list' ?
                    <>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.NID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CGUESTID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CGUESTNAME}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CGUESTDESC}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.CGUESTADDRESS}
                            </Typography>
                        </TableCell>
                    </>
                    :
                    <>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.NID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CGUESTID'
                                value={editData.CGUESTID}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CGUESTNAME'
                                value={editData.CGUESTNAME}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CGUESTDESC'
                                value={editData.CGUESTDESC}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='CGUESTADDRESS'
                                value={editData.CGUESTADDRESS}
                                onChange={handleEditChange}
                            />
                        </TableCell>
                    </>
                }
                <TableCell align="right" sx={{ minWidth: '252px' }}>
                    <ActionButtons status={status} setStatus={setStatus} expandOpen={expandOpen} setExpandOpen={setExpandOpen} type={'guest'} tickIconFunction={tickIconFunction} handleDelete={handleDelete} handleEdit={handleEdit} cancelIconFunction={cancelIconFunction} setDeleteDialogOpen={setDeleteDialogOpen} deleteDialogOpen={deleteDialogOpen} viewIconFunc={viewIconFunc} addIconFunc={addIconFunc} />
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={6} style={{ padding: 0 }}>
                    <Collapse in={expandOpen} timeout="auto" unmountOnExit>
                        <Card sx={{ bgcolor: 'grey.200' }} >
                            <GuestChildTable expandOpen={expandOpen} rowData={rowData} handleEditChange={handleEditChange} status={status} editData={editData} />
                        </Card>
                    </Collapse>
                </TableCell>
            </TableRow>
            <CreationDialog setOpen={setAddDialogOpen} open={addDialogOpen} maxWidth='sm'>
                <AddDesign setAddDialogOpen={setAddDialogOpen} rowDatas={rowData} setDuplicateDialogOpen={setDuplicateDialogOpen} setDupRfid={setDupRfid} />
            </CreationDialog>
            <CreationDialog setOpen={setViewDialogOpen} open={viewDialogOpen} maxWidth='md'>
                <ViewDesign setViewDialogOpen={setViewDialogOpen} />
            </CreationDialog>
            <CreationDialog setOpen={setDuplicateDialogOpen} open={duplicateDialogOpen} maxWidth='sm'>
                <DuplicationDesign setDuplicateDialogOpen={setDuplicateDialogOpen} rfid={dupRfid} />
            </CreationDialog>
        </>
    )

}

export default GuestTableRow